import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Hero.css";
import "../../Pages/LandingPage/LandingPage.css";
import { captureeventbaseanalytics } from "../../Libraries/Media";
import video1 from "../../Assets/Images/Video-2.mp4";
import { Link, useLocation, useNavigate } from "react-router-dom"; 

function Hero() {
  const navigate = useNavigate();
  const location = useLocation();
  const handleAnalytic = () => {
    captureeventbaseanalytics(
      "Landing",
      "BoostBoard_BannerCTA_FreeTrial",
      "User clicked Free Trial button"
    );
  };
  useEffect(() => {
    if (location.hash === "#support") {
      const targetElement = document.getElementById("support");
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.hash]); // Listen to hash changes

  return (
    <section id="Solution">
      <Container className="py-5">
        <Row>
          <Col lg={6} md={12} sm={12}>
            <div className="home-info">
              <h1>
                <span className="maintitle ">
                  Turn your TVs into{" "}
                  <span className="mainhighlight">digital</span>
                  <p>
                    <span
                      className="mainhighlight"
                      style={{ marginTop: "-0.9rem" }}
                    >
                      billboards{" "}
                    </span>
                  </p>
                </span>
              </h1>
              <p className="submaintitle subtitle-width">
                Boostboard digital signage solution helps you boost efficiency,
                increase brand visibility and improve customer experience, for
                free.{" "}
              </p>
              <div className="button-container" style={{ width: "100%" }}>
                {/* <Link
                  // to="https://boostboard.nayatel.com/cms"
                  // to="https://boostboard.nayatel.com/cms/signup"
                  target="_blank"
                  rel="noopener noreferrer"
                > */}
                  <Button
                    // variant="primary"
                    className="section-btn-1"
                    onClick={handleAnalytic}
                    href="signup"
                  >
                    Sign up for FREE
                  </Button>
                {/* </Link> */}

                {/* <Link to="/cms/landingpage#support">
                  <Button
                    variant="outline-primary"
                    className="section-btn-2 btn-2"
                    onClick={(e) => {
                      e.preventDefault();
                      const targetElement = document.getElementById("support");
                      if (targetElement) {
                        targetElement.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                      }
                    }}
                  >
                    Custom
                  </Button>
                </Link> */}
                 <Button
                  variant="outline-primary"
                  className="section-btn-2 btn-2"
                  onClick={() => {
                    navigate("#support", { replace: true }); // Update URL with hash
                    setTimeout(() => {
                      const targetElement = document.getElementById("support");
                      if (targetElement) {
                        targetElement.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                      }
                    }, 100); 
                  }}
                >
                  Contact Sales
                </Button>
              </div>
              <p className="lasttitle">No credit card required</p>
            </div>
          </Col>

          <Col lg={6} md={12} sm={12}>
            <div style={{ float: "right", border: "none" }}>
              <video
                autoPlay
                loop
                muted
                playsInline
                width="90%"
                height="auto"
                className="video"
                style={{ paddingTop: "5.7rem" }}
              >
                <source src={video1} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Hero;

// https://bbcontent.nayatel.com/content/tour_guide_video_clips/bb_landing_page_tutorial.mp4
